export default __webpack_public_path__ + "static/media/eye.85bab002.svg";